import {Link, List, ListItem, ListItemText, ListSubheader} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {useSelector} from "react-redux";

const coineus_fund_address = "0xb80267eA7fa368374ee4d4Bf10044778232AdEFe";

export default function CoineusMenu(props) {

    const {wallet} = useSelector(state => state.coineus);

    return (<List>

        <ListSubheader>COINEUS.APP</ListSubheader>
        <ListItem button component={RouterLink} to={'/'}>
            <ListItemText primary="Dashboard" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>
        <ListItem button component={Link}
                  href={"https://debank.com/profile/0xb80267eA7fa368374ee4d4Bf10044778232AdEFe/"}
                  target="_blank">
            <ListItemText primary="Fund Holdings" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>

        {wallet.address?.toLowerCase() === coineus_fund_address.toLowerCase() &&
            <ListItem button component={RouterLink} to={'/admin'}>
                <ListItemText primary="Admin" primaryTypographyProps={{style: {fontWeight: 700}}}/>
            </ListItem>}

        <ListSubheader>CEUS TOKEN</ListSubheader>
        <ListItem button component={Link}
                  href={'https://explorer.fuse.io/token/0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8'}
                  target="_blank">
            <ListItemText primary="Contract" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>
        <ListItem button component={Link}
                  href={'https://app.voltage.finance/swap'}
                  target="_blank">
            <ListItemText primary="Buy" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>
        <ListItem button component={Link}
                  href={'https://www.dextools.io/app/en/fuse/pair-explorer/0x22305a160abc6890eb7727f2b8a034d7fe56e883?t=1764871784669'}
                  target="_blank">
            <ListItemText primary="Chart" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>

        <ListSubheader>SOCIAL</ListSubheader>
        <ListItem button component={Link} href={'https://t.me/coineusportal'} target="_blank">
            <ListItemText primary="Telegram" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>
        <ListItem button component={Link} href={'https://twitter.com/CoineusCrypto'} target="_blank">
            <ListItemText primary="Twitter" primaryTypographyProps={{style: {fontWeight: 700}}}/>
        </ListItem>
    </List>)
}